import select from 'dom-select'
import on from 'dom-event'
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y'

// Fix Klaviyo popup form ADA
export default () => {
  window.addEventListener('klaviyoForms', event => {
    setTimeout(() => {
      if (event.detail.type === 'open') {
        const wrapper = select('.klaviyo-form')
        if (!wrapper) return

        const modal = select('[class*=ModalContent__ModalContentStyled]', wrapper)
        const closeButton = select('[class*=DismissButton]', wrapper) || select('button[aria-label="Close dialog"]', wrapper) || select('button[class*=close]', wrapper)

        // Apply dialog role and label to the best available element, falling
        // back to the outer wrapper so the popup is always labelled.
        const dialogEl = modal || wrapper
        dialogEl.setAttribute('role', 'dialog')
        dialogEl.setAttribute('aria-modal', 'true')
        dialogEl.setAttribute('aria-label', 'Marketing offer')

        // Fix generic alt text on the Klaviyo popup logo
        const logoImg = select('img[alt="popup logo"]', wrapper)
        if (logoImg) logoImg.setAttribute('alt', 'Hu Kitchen logo')

        if (closeButton) {
          closeButton.focus()
          trapFocus(wrapper)

          on(closeButton, 'keydown', (e) => {
            if (e.key === 'Space' || e.keyCode === 32 || e.key === 'Enter' || e.keyCode === 13) {
              e.preventDefault()
              wrapper.outerHTML = ''
              removeTrapFocus()
            }
          })
        }
      }
    }, 500)
  })
}
